<script>
import components from './edit-item.component'
import { getValidateStatus, getValidateStatusIcon, transformValidate } from './edit-item.validate'
// 2018-7-5 17:48:18 暴露方法供外部注册
const registerComponents = function (config) {
  for(const [componentName, opt] of Object.entries(config)){
    components[componentName] = opt
  }
}
// 给所有原生事件绑定this为item
const getNativeOnObjWithItem = (vm, item) => {
  let on = item.nativeOn || {}
  let bindOn = {}
  for (let event in on) {
    bindOn[event] = on[event].bind(item)
  }
  return bindOn
}
// 给所有组件内部事件绑定this为item
const getOnObjWithItem = (vm, item) => {
  let on = item.on || {}
  let bindOn = {}
  // 1. 设置默认change事件
  let defaultChange = components[item.type].defaultChange
  item.defaultChange = defaultChange // 2018-5-31 11:28:50 给item绑定一个defulatChange事件，供外部调用
  if (defaultChange) bindOn['change'] = defaultChange.bind(item)

  // 2. 给所有事件绑定item到外部的this
  for (let event in on) {
    bindOn[event] = on[event].bind(item)
  }
  // 3. 内置input事件实现双向绑定
  bindOn['input'] = (...arg) => {
    // 2018-10-24 17:00:42 input时取消校验状态
    vm.errorMsg = null
    const newVal = arg[0]
    item.value = newVal
    on['input'] && on['input'].bind(item)(...arg)
  }

  // 4. validate获取所有的校验触发事件, 并绑定所有事件
  let rulesObj = vm.rulesObj = transformValidate(vm, item) // 存进vm实例当中，供外部主动校验
  for (let [event, validate] of Object.entries(rulesObj)) {
    let tmplEvent = bindOn[event] // 记录保存上面绑定过的事件
    bindOn[event] = (...arg) => {
      // console.log(item.type, vm.errorMsg)
      tmplEvent && tmplEvent(...arg)
      validate()
    }
  }

  return bindOn
}
// 获取所有插槽的VNnode
const getChildrenVNode = function (vm, item) {
  // const r = vm.$createElement
  // 先取父级的slots，再取爷爷级是slots
  const slots = vm.$slots[item.key] || item.slots
  let childrenVNode = []
  if (slots) { // 默认插槽
    // childrenVNode.push(...slots.map(slot => (slot.context = vm._self, slot)))
    childrenVNode.push(...slots.map(slot => {
      slot.context = vm._self
      return slot
    }))
  }
  return childrenVNode
}

// 2018-9-20 17:06:21 获取插槽
const getScopedSlots = function (vm, item) {
  let scopedSlots = {}
  // let scopedSlotsTotal = Object.assign({}, item.scopedSlotsOut || {}, vm.$scopedSlots)
  for(const [slotStr, scopedSlot] of Object.entries(vm.$scopedSlots)){
    const [slotKey, slotName] = slotStr.split('__')
    if(slotKey === item.key) {
      if(slotName) {
        scopedSlots[slotName] = function (scope) {
          return scopedSlot(scope)
        }
      }else {
        // item.scopedSlot = scopedSlot // 把默认插槽存进item，供select-cell和async-select使用
        scopedSlots.default = scopedSlot
      }
    }
  }
  return Object.keys(scopedSlots).length ? scopedSlots : null
}

// 渲染所有component
const renderComponent = (vm, item) => {
  let r = vm.$createElement
  const componentJson = components[vm.editable && item.type]
  const component = componentJson.component // 具体组件
  const getDefaultProps = componentJson.getDefaultProps // 获取默认props函数
  const defaultProps = getDefaultProps ? getDefaultProps(item) : {} // 默认的props对象
  let properties = Object.assign(defaultProps, item.props) // 组装默认和传入的props
  let attrs = {}
  for (const [key, value] of Object.entries(properties)) {
    if (!component.props[key]) { // 如果是表单组件的props就设置否则设置为attrs
      attrs[key] = value
    }
  }
  return r(
    component,
    {
      props: {
        item: item,
        value: item.value,
        'suffix-icon': item.statusIcon && getValidateStatusIcon(vm.errorMsg),
        ...properties // 预防遗漏所以把attrs和props都放进去
      },
      attrs,
      // 注册组件内事件
      on: getOnObjWithItem(vm, item),
      // 注册原生事件
      nativeOn: getNativeOnObjWithItem(vm, item),
      // 插入插槽
      scopedSlots: getScopedSlots(vm, item)
    },
    [getChildrenVNode(vm, item)]
  )
}
export default {
  name: 'EditItem',
  registerComponents,
  data () {
    return {
      components,
      rulesObj: {},
      errorMsg: null
    }
  },
  props: {
    item: Object,
    editable: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    editable () {
      // 每次变化的时候把校验清空
      this.errorMsg = null
    }
  },
  methods: {
    validate () {
      return {
        // 主动校验所有rules
        flag: Object.values(this.rulesObj).every(validate => {
          return validate()
        }),
        msg: this.errorMsg
      }
    }
  },
  render (r) {
    let item = this.item
    // 针对textarea等高度不限制设置class为height-auto
    const getHeightClass = () => {
      if (item.type === 'input' && item.props && item.props.type === 'textarea') {
        return item.type + ' height-auto'
      }
      return item.type
    }
    return r(
      'el-form-item',
      {
        staticClass: 'my-edit-item',
        class: [
          item.class && item.class, // 增加外部添加class类
          getHeightClass(),
          item.statusIcon && getValidateStatus(this.errorMsg),
          item.statusIcon && 'el-form-item--feedback'
        ],
        props: {
          label: item.label,
          required: item.required,
          ...item.itemProps
        }
      },
      [ renderComponent(this, item),
        this.errorMsg && r(
          'div',
          {
            attrs: {
              class: 'el-form-item__error'
            }
          },
          this.errorMsg
        )
      ]
    )
  }
}
</script>
